export class ImageSettings {
  constructor(c = {}) {
    Object.assign(this, {
      url: '',
      link: '',
      margin: { marginLeft: 10, marginRight: 10, marginTop: 10, marginBottom: 10 },
      border: { borderWidth: 0, borderColor: '#000000', borderTopLeftRadius: 5, borderTopRightRadius: 5, borderBottomLeftRadius: 5, borderBottomRightRadius: 5, borderStyle: 'solid' },
      width: { type: 'auto', value: 100 },
      height: { type: 'auto', value: 100 },
      align: 'left',
      alt: '',
    });
    Object.assign(this, c);
  }
}


export const ImageTypes = {
  content: {
    url: { title: 'URL', type: 'Input' },
    alt: { title: 'alt text', type: 'Input' },
  },
  link: {
    link: { title: 'Link', type: 'Input' }
  },
  orientation: {
    width: { title: 'Width', type: 'Size' },
    height: { title: 'Height', type: 'Size' },
    margin: { title: 'Margin', type: 'Margin' },
    align: { title: 'Image Align', type: 'Align' },
  },
  styles: {
    border: { title: 'Border', type: 'Border' },
  }
};